import React from 'react';

class PetRecords extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    downloadButton(record) {
        let images = record.images

        if (images && images.length > 0) {
            return (
                <a target="_blank" href={images[0] && images[0].url}>
                    <i className="fa fa-arrow-circle-down download-btn"></i>
                    <span className="download-text">Download Attachment</span>
                </a>
            )
        } else if (record.url) {
            return (
                <a className="view-icon" href={record.url} target="_blank">
                    <i className="fa fa-eye download-btn"></i>
                    <span className="download-text">View</span>
                </a>
            )
        }
    }

    render() {
        return (
            <div className="records-container">
                {this.props.pet && this.props.pet.records && this.props.pet.records.map((record, index) => (
                    <div className="services-list__item" key={record.id}>
                        <div>
                            <h3 className="services-list__item__title">{record.title}</h3>
                            <p className="services-list__item__text">Date
                                :{new Date(record.entry_date).toLocaleString('en-US').split(',')[0]}</p>
                            <p className="services-list__item__text">{record.notes}</p>
                            <div>
									<span className="services-list__item__price">
	                                    <span className="services-list__item__price--dollar"/>
                                        {record.record_type}
	                                </span>
                            </div>
                            {this.downloadButton(record)}
                        </div>
                    </div>
                ))}


            </div>
        );
    }
}

export default PetRecords;